
import { useEffect, useState } from "react";
import './styles/update.css';
import Timer from "./Timer";

function Update({updateToFrame,frameToUpdate,message,length, isSolve,id1,id2}) {

    // console.log("in update")
    const [dis,setdis] = useState(false);
    const [showLong, setShowLong] = useState('none');
    const [showShort, setShowShort] = useState('');



    const onEnter = (e) =>{

        if(e.key === 'Enter'){
            if(e.target.value.match(/[a-zA-Z]/gi)){
                // console.log("we read capital input")
                updateToFrame(e.target.value);
            } else {
                updateToFrame('(wrong input)')
            }
            setdis(true);
            // clearme();
            e.target.value =""

        }
    }

    useEffect(() => {

        if(frameToUpdate === 'show'){
            setdis(false);
            clearme();
            console.log('here')
        }else if(frameToUpdate === 'hide') {
            setdis(true);
        } 

        if(isSolve === 'small'){
            // console.log(isSolve);
            setShowShort('');
            setShowLong('none');
        } else if( isSolve === 'large'){
            // console.log(isSolve);
            setShowLong('');
            setShowShort('none');
        }

    },[frameToUpdate])

    // i tried to pass ids dynamically
    const clearme = ()=>{
        // // console.log("we made it clearme problem: "+document.getElementById('input2').value)
        // if(id1){
        //     document.getElementById({id1}).value = '';
        // document.getElementById({id2}).value = '';
        // }
        
        /*
        this method clear it up
        by it clears it up based on its ID
        i think the ID is only valid for a single render 
        then it become ineffective
        i will pass new ids everytime we render as props then assign them and hope it works lol
        */
    }

    
    // console.log("we made it clearme problem: "+document.getElementById('input2').value)
    // }
    return(
        <div className="updateBody">

            <div className="updateStatus">

                <div className="updateText">
                    <h1>
                        {message}                   
                    </h1>
                </div>

                <div className="updateTimer">
                    <Timer/>
                </div>
                
            </div>

            <input id={id1}className="textbox" style={{display: showShort}} disabled={dis} maxLength={1} onChange={(e) => 
                    {
                        if(e.target.value.match(/[a-zA-Z]/gi)){
                            // console.log("we read capital input")
                            updateToFrame(e.target.value);
                        } else {
                            updateToFrame('(wrong input)')
                        }
                        e.target.value = ""
                        // updateToFrame(e.target.value);
                    setdis(true);}}>
            </input>  
            
            <input id={id1} className="textbox2" style={{display: showLong}} onKeyDown={onEnter} disabled={dis} maxLength={50} >
            </input>  
            
        </div>
    );
    
}

export default Update